import {SessionModel} from './session.model';
import {createBasketSession} from '../../basket/model';

export const PROMOCODE_KEY = 'promoCode';

export const createSession = (payload: any = {}): SessionModel => {
  const basketSession = createBasketSession(payload.basket);

  return {
    sessionId: payload.sessionId,
    engineId: payload.engineId,
    groupId: payload.groupId,
    display: payload.display,
    context: payload.context,
    basket: basketSession,
    roomFilters: payload.roomFilters,
    hotelFilters: payload.hotelFilters,
    roomSortType: payload.roomSortType,
    hotelSortType: payload.hotelSortType,
    isMonoHotel: payload.isMonoHotel,
    defaultDistance: payload.defaultDistance,
  };
};
